// -------------------------------------------
// JavaScript Responsive Navigation
// Author: Globalia
// Licensed under the WTFPL license
// -------------------------------------------
// Toggle behavior-attached classes on navigation

( function( global ) { // eslint-disable-line

    var pluginName = 'grTable';

    //  Methods
    // --------------------------------------------------------------------------

    function grTable(selector) {

        // Create global references
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;

        // Init grPlugin
        this.init();
    }

    //  jQuery wrapper, if available
    // --------------------------------------------------------------------------

    grTable.prototype.init = function init() {
        if (this.selector === null) {
            throw new Error(pluginName + ': fail - something wrong with your selector');
        } else {
            this.setTitles();

            // Flag the plugin as ready
            this.ready = true;
            global.methods.toggleAttributeValue(this.selector, 'gr-table', 'ready');
            if (global.verbose) console.log(pluginName + '(' + this.selector.id + '): ready');
        }
    }

    grTable.prototype.setTitles = function setTitle() {
        var ths = this.selector.querySelectorAll('th');
        var trs = this.selector.querySelectorAll('tr');
        var titles = [];

        for (var i=0; i < ths.length; i++) {
            titles.push(ths[i].innerHTML);
        }

        for (var i=0; i < trs.length; i++) {
            for (var j=0; j < trs[i].children.length; j++) {
                trs[i].children[j].setAttribute('gr-table-title', titles[j]);
            }
        }
    }

    // Destroy - remove listeners to prevent from memory leak
    grTable.prototype.destroy = function destroy() {
        global.methods.removeAttributeValue(this.selector, 'gr-table', 'ready');
        if (global.verbose) console.log(pluginName + ': destroyed');
    };

    //  jQuery wrapper, if available
    // --------------------------------------------------------------------------

    if(window.jQuery) {
        $.fn[pluginName] = function () {
            return this.each(function() {
                // add plugin to element data
                if (!$.data(this, pluginName) ) $.data(this, pluginName, new grTable(this));
            });
        };
    }

    //  Auto-Instantiation
    // --------------------------------------------------------------------------

    var all = {}, index;
    if (document.querySelectorAll('[gr-table]').length) {
        window.groots.grTable = { instances: {} };
        all = document.querySelectorAll('[gr-table]');
        index = -1;
        while (all[++index])
            global.grTable.instances[index] = new grTable(all[index]);
    }

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = grTable;
    // Export to Browser
    else global[pluginName] = grTable; // eslint-disable-line

}( window.groots ));
